// extracted by mini-css-extract-plugin
export default {"actionBtn":"Update_actionBtn__0ZhP2","confirm":"Update_confirm__H8uFp","reject":"Update_reject__bG0C+"};